import React from 'react';
import { Text } from '@carnica/ui-kit';
import classNames from 'classnames/bind';
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
/** Футер карточки */
export var Footer = function Footer(_ref) {
  var priceText = _ref.priceText,
    priceTextTop = _ref.priceTextTop;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('component'),
    "data-t-id": "components-Footer"
  }, priceTextTop && /*#__PURE__*/React.createElement(Text, {
    color: "tertiary-invert",
    size: "xs"
  }, priceTextTop), /*#__PURE__*/React.createElement(Text, {
    color: "primary-invert",
    size: "xs"
  }, priceText));
};